import Vue from 'vue';
import Vuex from 'vuex';
import CDWMHJZS20201231 from '@/views/20201231CDWMHJZS/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pointOut: false,
  },
  mutations: {
    changePointOut(state, data) {
      state.pointOut = data;
    },
  },
  actions: {},
  modules: {
    CDWMHJZS20201231,
  },
});
